import {useSelector} from 'react-redux';

import {KlarnaAddressType} from 'desktop/types/klarnaTypes';

import {useGetCustomerEmail} from 'hooks/getCustomerData/getCustomerData';
import {useGetRegions} from 'hooks/location/location';

import {getBillingAddress} from '../../store/selectors/billingAddress/billingAddress';
import {getShippingAddress} from '../../store/selectors/shippingAddress/shippingAddress';

/**
 * Get shipping address for klarna
 * @param {AddressType} address - current address
 * @param {LocationDefaultStateType} location - current location
 * @param {string} email - current email
 * @return {KlarnaAddressType} address for Klarna
 */
export const useGetShippingAddressForKlarna = (): KlarnaAddressType => {
    const address = useSelector(getShippingAddress);
    const {regions: states} = useGetRegions(address.country.value);
    const email = useGetCustomerEmail();

    const currentAddress: {[key: string]: string} = Object.keys(address).reduce(
        (acc, key) => ({...acc, [key]: address[key].value}),
        {},
    );
    currentAddress.state =
        (states?.[currentAddress.country] || []).find(state => state.id === currentAddress.state)
            ?.value ?? currentAddress.state;
    return {
        city: currentAddress.city,
        country: currentAddress.country,
        email: currentAddress.email || String(email),
        familyName: currentAddress.lastName,
        givenName: currentAddress.firstName,
        phone: currentAddress.phone,
        postalCode: currentAddress.postal,
        region: currentAddress.state,
        streetAddress: currentAddress.address,
        streetAddress2: currentAddress.other,
    };
};

/**
 * Get billing address for klarna
 * @param {AddressType} address - current address
 * @param {LocationDefaultStateType} location - current location
 * @param {string} email - current email
 * @return {KlarnaAddressType} address for Klarna
 */
export const useGetBillingAddressForKlarna = (): KlarnaAddressType => {
    const address = useSelector(getBillingAddress);
    const {regions: states} = useGetRegions(address.country.value);
    const email = useGetCustomerEmail();

    const currentAddress: {[key: string]: string} = Object.keys(address).reduce(
        (acc, key) => ({...acc, [key]: address[key].value}),
        {},
    );
    currentAddress.state =
        (states?.[currentAddress.country] || []).find(state => state.id === currentAddress.state)
            ?.value ?? currentAddress.state;
    return {
        city: currentAddress.city,
        country: currentAddress.country,
        email: currentAddress.email || String(email),
        familyName: currentAddress.lastName,
        givenName: currentAddress.firstName,
        phone: currentAddress.phone,
        postalCode: currentAddress.postal,
        region: currentAddress.state,
        streetAddress: currentAddress.address,
        streetAddress2: currentAddress.other,
    };
};
